import api from "../../../services/apiClient"
import type { TravelersCheckDetail, TravelersCheckFormValues } from "../models/travelersCheck"

const BASE = "travelers-check"

export const travelersCheckApi = {
  getList: async (params?: Record<string, unknown>) => {
    const { data } = await api.get(BASE, { params })
    return data?.data ?? data
  },

  getById: async (id: number): Promise<TravelersCheckDetail> => {
    const { data } = await api.get(`${BASE}/${id}`)
    return data?.data ?? data
  },

  create: async (values: TravelersCheckFormValues) => {
    const { data } = await api.post(`${BASE}/create`, values)
    return data?.data ?? data
  },

  update: async (id: number, values: TravelersCheckFormValues) => {
    const { data } = await api.put(`${BASE}/update/${id}`, values)
    return data?.data ?? data
  },

  delete: async (id: number) => {
    const { data } = await api.delete(`${BASE}/delete/${id}`)
    return data
  },

  requestRedeem: async (id: number, payload: { redeem_file: number; issuing_file?: number }) => {
    const { data } = await api.post(`${BASE}/request-redeem/${id}`, payload)
    return data?.data ?? data
  },

  requestRedeemForm: async (payload: { travel_check_id: number; issuing_file: number; redeem_file: number }) => {
    const { data } = await api.post(`${BASE}/request-redeem-form`, payload)
    return data?.data ?? data
  },

  handleRedeemRequest: async (id: number, accept: boolean) => {
    const { data } = await api.post(`${BASE}/handle-redeem-request/${id}`, { accept })
    return data?.data ?? data
  },

  redeem: async (id: number) => {
    const { data } = await api.post(`${BASE}/redeem/${id}`)
    return data?.data ?? data
  },

  getAgencies: async () => {
    const { data } = await api.get(`${BASE}/agencies`)
    return data?.data ?? data
  },

  downloadPdf: async (id: number) => {
    const { data: blob } = await api.get(`${BASE}/download-pdf/${id}`, { responseType: "blob" })
    const url = window.URL.createObjectURL(blob)
    const a = document.createElement("a")
    a.href = url
    a.download = `cheque_viagem_${id}.pdf`
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
    window.URL.revokeObjectURL(url)
  },
}
